import { Component } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { MatDialog } from '@angular/material';
import { generalService } from '../../services/general.service';

@Component ({
  selector: 'entradaAlmacen-component',
  templateUrl: 'entrada-almacen.component.html',
  providers: [generalService]
})

export class EntradaAlmacenComponent {
  constructor(public dataService: DataService,
              public dialog: MatDialog  ){ }

  ngOnInit() { }

}






// WEBPACK FOOTER //
// ./src/app/almacen/entradas/entrada-almacen.component.ts